import { MutationTree } from 'vuex'

import { blankCustomerMultiplier } from './constants'
import State, { ICustomerMultiplier } from './types'

export const mutations: MutationTree<State> = {
  customerMultipliersLoaded(state: State, multipliers: ICustomerMultiplier) {
    state.error = false
    state.customerMultipliers = multipliers
  },
  customerMultipliersError(state) {
    state.error = true
    state.customerMultipliers = blankCustomerMultiplier
  },
  customerMultipliersCleared(state) {
    state.error = false
    state.customerMultipliers = blankCustomerMultiplier
  },
}
